import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { Storage } from '@/enums/storage.enum';
import store from '@/store/store';
import { config } from '@/utils/config';

export const EditViewHtmlRoute: RouteConfig = {
  path: 'editView/:viewId',
  name: 'editViewHtml',
  component: () => import(/* webpackChunkName: "EditViewHTML" */ '@/views/mainRoute/document/details/EditViewHtml.vue'),
  beforeEnter: (to, from, next) => {
    const url = `${config.renderURL}/preview/document/${to.params.documentId}/${to.params.viewId}`;
    let previewData = store.state.view.previewData;
    if (previewData) {
      localStorage.setItem(Storage.HTML_EDIT, JSON.stringify(previewData));
    } else {
      previewData = JSON.parse(localStorage.getItem(Storage.HTML_EDIT) as string);
    }
    const body = { ...previewData, [config.tokenFormField]: localStorage.getItem(Storage.TOKEN) };
    store
      .dispatch('view/getPreview', { url, body })
      .then(() => {
        next();
      })
      .catch(err => store.dispatch('notifyError', { title: Errors.VIEW_CANNOT_GET }));
  }
};
